

export enum BookingAddressType {
    Pickup = "Pickup",
    Drop = "Drop",
}

export enum TripType {
    OneWayTrip = "ONE_WAY_TRIP",
    RoundTrip = "ROUND_TRIP"
}

export enum CarType {
  SEDAN = 'Sedan',
  SUV = 'SUV',
  HATCHBACK = 'Hatchback',
}

export enum TransmissionType {
  MANUAL = 'Manual',
  AUTO = 'Auto',
}

export enum DriverBookingType {
  BASE_FARE = "BASE_FARE",
  ADDITIONAL_FEES = "ADDITIONAL_FEES"
}

export enum DateTimeWheelType {
  DAY = 'day',
  TIME = 'time',
  MERIDIEM = 'meridiem'
}

export const meridiemList = ['AM', 'PM'];

export const availableBookingDates = new Array(7)
.fill(new Date())
.map((currDate, index) => {
  const newDate = new Date(currDate);
  return newDate.setDate(currDate.getDate() + index);
});

export const PossibleSlotsStartTime = "09:00 AM";